import React from 'react'
import { Grid, PageSection } from '@superhi/design'

import { Items, Item } from './styles'

const DATA = [
  'aiga',
  'deliveroo',
  'nyt',
  'google',
  'apple',
  'ableton',
  'conde-nast',
  'kickstarter',
  'microsoft',
  'pinterest',
  'gucci',
  // 'deloitte',
]

const PADDING: Record<string, string> = {
  aiga: '0',
  deliveroo: '0',
  nyt: '0.5% 0 0 0',
  google: '0.5% 0 0 0',
  apple: '0 0 0.25% 0',
  ableton: '0 0 0.3% 0',
  'conde-nast': '0 0 0.2% 0',
  kickstarter: '0',
  microsoft: '0',
  pinterest: '0',
  gucci: '0',
}

const Companies: React.FC<React.PropsWithChildren<unknown>> = () => (
  <PageSection noBottomPadding collapseTopPadding>
    <Grid>
      <Grid.Cell span="full">
        <Items>
          {DATA.map((data) => (
            <Item key={data} $padding={PADDING[data]}>
              {/* Disabling following line since next/image CSS throws out spacing, and raw image isn’t supported yet  */}
              {/* eslint-disable-next-line */}
              <img src={`/images/company-logos/${data}.svg`} alt={data} width={136} height={50} />
            </Item>
          ))}
        </Items>
      </Grid.Cell>
    </Grid>
  </PageSection>
)

export default Companies
